function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefault = function SvgDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 1.333 1.333"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1327.892 969.233s15.51-71.685 22.042-82.5c8.807-14.582 70.609-26.785 70.609-26.785s62.933 8.91 71.356 22.857c7.168 11.869 26.525 86.428 26.525 86.428z",
    clipPath: "url(#default_svg__clipPath5736)",
    style: {
      fill: "#ff0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327.892 969.233s15.51-71.685 22.042-82.5c8.807-14.582 70.609-26.785 70.609-26.785s62.933 8.91 71.356 22.857c7.168 11.869 26.525 86.428 26.525 86.428z",
    clipPath: "url(#default_svg__clipPath5736-4)",
    style: {
      fill: "#ff0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327.892 969.233s15.51-71.685 22.042-82.5c8.807-14.582 70.609-26.785 70.609-26.785s62.933 8.91 71.356 22.857c7.168 11.869 26.525 86.428 26.525 86.428z",
    clipPath: "url(#default_svg__clipPath5736-9)",
    style: {
      fill: "#ff0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1.333v1.333H0Z",
    style: {
      fill: "#ececec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.667.317a.4.4 0 0 0-.08.01q.003.008.007.02L.6.37l.053.174L.7.542.732.54.756.54h.02Q.838.54.88.555a.12.12 0 0 1 .058.045.11.11 0 0 1 .007.11.12.12 0 0 1-.061.06L.841.786a.2.2 0 0 1 .11.037l.02.02A.352.352 0 0 0 .667.317M.51.354H.507L.43.569h.14zM.463.383a.35.35 0 0 0-.131.393A1 1 0 0 1 .36.666V.665L.454.408zM.76.57a.3.3 0 0 0-.047.004v.2h.04q.058 0 .082-.027A.1.1 0 0 0 .861.673.12.12 0 0 0 .837.6Q.813.57.761.57M.425.602c-.044.134.04.175.03.252C.453.886.43.902.408.906a.35.35 0 0 0 .203.11l.005-.003q.01-.007.01-.024L.629.935V.799C.628.776.627.755.618.72L.604.678.583.602zm.29.203v.208l.015.002h.002A.35.35 0 0 0 .898.934L.9.914a.1.1 0 0 0-.012-.05.1.1 0 0 0-.041-.042.2.2 0 0 0-.085-.017z",
    style: {
      fill: "#ccc"
    }
  }));
};
export default SvgDefault;